// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"e864d692","468":"349b8453"}[chunkId] + ".chunk.css";
};